import { useEffect } from "react";

const HEADER_OFFSET = 120;

export const scrollToId = (id, behavior = "smooth") => {
  const el = id && document.getElementById(id);
  if (!el) return false;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  window.scrollTo({ top: Math.max(0, top), behavior: reduce ? "auto" : behavior });
  return true;
};

// Scrolls to the URL hash on load, on hashchange, and when a same-page "#id" link is clicked
// (including re-clicking the current hash, which fires no hashchange event).
export const useHashScroll = () => {
  useEffect(() => {
    const go = () => scrollToId(decodeURIComponent(window.location.hash.slice(1)));
    const t = setTimeout(go, 150);
    const onClick = (e) => {
      const a = e.target.closest?.("a[href]");
      if (!a || a.target === "_blank") return;
      const url = new URL(a.getAttribute("href"), window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
      e.preventDefault();
      if (url.hash !== window.location.hash) window.history.pushState(null, "", url.hash);
      scrollToId(decodeURIComponent(url.hash.slice(1)));
    };
    window.addEventListener("hashchange", go);
    document.addEventListener("click", onClick);
    return () => { clearTimeout(t); window.removeEventListener("hashchange", go); document.removeEventListener("click", onClick); };
  }, []);
};
